import { TEXT_HIDDEN } from 'utility/constant';
import { getAmount } from 'utility/functions';
import styles from './IlMioSaldoListItem.module.scss';
import { useIsDarkTheme } from 'hooks/useIsDarkTheme';
import { useMemo } from 'react';
import { useTypedSelector } from 'lib/centralStore';

export type IlMioSaldoListItemProps = {
  name: string;
  value: number;
  index: number;
  containerClassName?: string;
};

export const IlMioSaldoListItem = ({ name, value, index, containerClassName }: IlMioSaldoListItemProps) => {
  const formatter = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  });
  const isSaldoVisibile = useTypedSelector((state) => state.dashboard.isSaldoVisible);

  const { isDarkMode } = useIsDarkTheme();
  const chartColors = useMemo(() => {
    if (isDarkMode) {
      return ['#EBFF00', '#EBFF00', '#EBFF00', '#EBFF00', '#EBFF00', '#EBFF00', '#EBFF00', '#EBFF00'];
    } else {
      return ['#0157FE', '#0157FE', '#0157FE', '#0157FE', '#0157FE', '#0157FE', '#0157FE', '#0157FE'];
    }
  }, [isDarkMode]);

  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <svg
        width="4"
        height="27"
        viewBox="0 0 4 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.pseudoElement}
      >
        <path opacity="1" d="M0 0H4V27H0V0Z" fill={chartColors[index]} />
      </svg>
      <p>{name}</p>
      <p>{isSaldoVisibile ? formatter.format(getAmount(value)) : TEXT_HIDDEN}</p>
    </div>
  );
};
